import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(4),
	},
	searchBar: {
		display: "flex",
		gap: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},
}));

const ProtocolSearch = () => {
	const classes = useStyles();
	const history = useHistory();
	const [searchParam, setSearchParam] = useState("");
	const [tickets, setTickets] = useState([]);
	const [searched, setSearched] = useState(false);

	const handleSearch = async e => {
		e.preventDefault();
		if (!searchParam.trim()) return;

		try {
			const { data } = await api.get("/tickets", {
				params: {
					searchParam: searchParam.trim(),
					showAll: "true",
					pageNumber: "1",
				},
			});
			setTickets(data.tickets);
			setSearched(true);
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<div className={classes.root}>
			<Container maxWidth="md">
				<Typography variant="h5" gutterBottom>
					Buscar por Protocolo
				</Typography>
				<form className={classes.searchBar} onSubmit={handleSearch}>
					<TextField
						label="Protocolo, nome ou número do contato"
						placeholder="Ex: PROTO-123"
						variant="outlined"
						size="small"
						fullWidth
						value={searchParam}
						onChange={e => setSearchParam(e.target.value)}
					/>
					<Button type="submit" variant="contained" color="primary">
						Buscar
					</Button>
				</form>

				<Paper variant="outlined">
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Protocolo</TableCell>
								<TableCell>Contato</TableCell>
								<TableCell>Status</TableCell>
								<TableCell align="center">Ação</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{tickets.map(ticket => (
								<TableRow key={ticket.id}>
									<TableCell>{ticket.protocol || "-"}</TableCell>
									<TableCell>{ticket.contact?.name}</TableCell>
									<TableCell>{ticket.status}</TableCell>
									<TableCell align="center">
										<Button
											size="small"
											onClick={() => history.push(`/tickets/${ticket.id}`)}
										>
											Abrir
										</Button>
									</TableCell>
								</TableRow>
							))}
							{searched && tickets.length === 0 && (
								<TableRow>
									<TableCell colSpan={4} align="center">
										Nenhum atendimento encontrado.
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</Paper>
			</Container>
		</div>
	);
};

export default ProtocolSearch;
